import React, { ReactNode, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box } from "@mui/material";
import { BankHealthFilterIntervalEnum } from "@bn/api/apiv3";
import { WithLoadingSpinner, NoDataStub } from "@components";
import { useChartOptions } from "@components/Chart/highcharts/LineChart/useChartOptions";

type Props = {
  chartData: [number, number][];
  isFetching?: boolean;
  noDataMessage?: ReactNode;
  mode: "success" | "failure";
  interval: BankHealthFilterIntervalEnum;
};

// @ts-ignore
Highcharts.seriesTypes.area.prototype.getPointSpline =
  // @ts-ignore
  Highcharts.seriesTypes.spline.prototype.getPointSpline;

export const LineChart = ({
  chartData,
  isFetching,
  noDataMessage,
  mode,
  interval,
}: Props) => {
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
  const chartOptions = useChartOptions(chartData, mode, interval);

  useEffect(() => {
    chartComponentRef.current?.chart?.reflow();
  }, [chartOptions]);

  return (
    <Box pb={4}>
      <WithLoadingSpinner isLoading={Boolean(isFetching)} mb={6}>
        {!chartData.length && !isFetching ? (
          <NoDataStub height="300px" secondLine={noDataMessage} />
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
            ref={chartComponentRef}
          />
        )}
      </WithLoadingSpinner>
    </Box>
  );
};
